import {useEffect, useState} from 'react';
import MyPlusApi from '@/api/main/my-plus';
import {isLogin} from '@/utils/main';

const useCatchList = (selectedMode) => {
  const [catchList, setCatchList] = useState([]);
  useEffect(() => {
    if (selectedMode === 'prefer' && isLogin()) {
      getPreferCatchList();
    } else {
      getPopularCatchList();
    }
  }, []);

  const getPreferCatchList = async () => {
    try {
      const response = await MyPlusApi.getPreferCatchList();
      if (response && response.data) {
        const transformedList = response.data?.list?.map((catchItem) => {
          const {
            thumb,
            titleNo,
            resolutionType,
            titleName,
            viewCnt,
            bjId,
            ...rest
          } = catchItem;

          return {
            ...rest,
            catchId: titleNo,
            thumbnailSrc: thumb,
            isHorizontal: resolutionType === 'horizontal',
            viewCount: viewCnt,
            title: titleName,
            userId: bjId,
          };
        });
        setCatchList(transformedList);
      }
    } catch (error) {
      setCatchList([]);
    }
  };

  const getPopularCatchList = async () => {
    try {
      const response = await MyPlusApi.getPopularCatchList();
      if (response && response.data) {
        const transformedList = response.data?.list?.map((catchItem) => {
          const {
            thumb,
            titleNo,
            resolutionType,
            titleName,
            viewCnt,
            bjId,
            verticalThumb,
            ...rest
          } = catchItem;

          return {
            ...rest,
            catchId: titleNo,
            thumbnailSrc:
              resolutionType === 'horizontal' ? thumb : verticalThumb,
            isHorizontal: resolutionType === 'horizontal',
            viewCount: viewCnt,
            title: titleName,
            userId: bjId,
          };
        });
        setCatchList(transformedList);
      }
    } catch (error) {
      setCatchList([]);
    }
  };
  return {catchList};
};

export default useCatchList;
